import type { Template } from "@/types";

export const LA_06_H5_V1: Template[] = [
    {
        id: "la-06-h5v1-01",
        name: "LA 01 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_01.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 77, y: 46, width: 208, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 198, width: 208, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 77, y: 350, width: 208, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 293, y: 46, width: 305, height: 448, rotation: 0, imageRotation: 0 },
            { id: "5", x: 842, y: 46, width: 344, height: 221, rotation: 0, imageRotation: 0 },
            { id: "6", x: 842, y: 275, width: 344, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-02",
        name: "LA 02 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 110, y: 46, width: 295, height: 448, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 412, y: 46, width: 144, height: 106, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 160, width: 144, height: 106, rotation: 0, imageRotation: 0 },
            { id: "4", x: 412, y: 274, width: 144, height: 106, rotation: 0, imageRotation: 0 },
            { id: "5", x: 412, y: 388, width: 144, height: 106, rotation: 0, imageRotation: 0 },
            { id: "6", x: 768, y: 107, width: 493, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-03",
        name: "LA 03 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_03.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 89, y: 87, width: 246, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 87, width: 245, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 275, width: 245, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 56, width: 420, height: 279, rotation: 0, imageRotation: 0 },
            { id: "5", x: 804, y: 343, width: 206, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 343, width: 206, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-04",
        name: "LA 04 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 157, y: 38, width: 336, height: 218, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 157, y: 264, width: 164, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 157, y: 388, width: 164, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 264, width: 164, height: 116, rotation: 0, imageRotation: 0 },
            { id: "5", x: 329, y: 388, width: 164, height: 116, rotation: 0, imageRotation: 0 },
            { id: "6", x: 849, y: 38, width: 330, height: 466, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-05",
        name: "LA 05 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 71, y: 81, width: 535, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 806, y: 52, width: 204, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 806, y: 201, width: 204, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 806, y: 349, width: 204, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 349, width: 204, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 52, width: 204, height: 289, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-06",
        name: "LA 06 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_06.png",
        size: [1352, 541],
        style: {},
        slots: [               
            { id: "1", x: 62, y: 95, width: 238, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 274, width: 238, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 308, y: 95, width: 237, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 308, y: 274, width: 237, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 553, y: 95, width: 214, height: 349, rotation: 0, imageRotation: 0 },
            { id: "6", x: 775, y: 95, width: 516, height: 349, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-07",
        name: "LA 07 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_07.png",
        size: [1352, 541],
        style: {},
        slots: [                
            { id: "1", x: 61, y: 95, width: 238, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 274, width: 238, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 95, width: 214, height: 349, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 95, width: 238, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 529, y: 274, width: 238, height: 170, rotation: 0, imageRotation: 0 },
            { id: "6", x: 775, y: 95, width: 516, height: 349, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-08",
        name: "LA 08 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 61, y: 95, width: 238, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 274, width: 238, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 95, width: 214, height: 349, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 95, width: 516, height: 349, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1053, y: 95, width: 238, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1053, y: 274, width: 238, height: 170, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-09",
        name: "LA 09 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 50, y: 43, width: 297, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 354, y: 43, width: 274, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 354, y: 326, width: 274, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 354, y: 226, width: 134, height: 92, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 226, width: 133, height: 92, rotation: 0, imageRotation: 0 },
            { id: "6", x: 635, y: 43, width: 668, height: 457, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h5v1-10",
        name: "LA 10 - H5V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h5_v1_10.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 107, y: 43, width: 158, height: 109, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 160, width: 158, height: 108, rotation: 0, imageRotation: 0 },
            { id: "3", x: 107, y: 276, width: 158, height: 108, rotation: 0, imageRotation: 0 },
            { id: "4", x: 107, y: 392, width: 158, height: 108, rotation: 0, imageRotation: 0 },
            { id: "5", x: 273, y: 43, width: 296, height: 457, rotation: 0, imageRotation: 0 },
            { id: "6", x: 577, y: 43, width: 668, height: 457, rotation: 0, imageRotation: 0 }
        ],
    }
];